import React from "react";
import { ArrowUpRight, Instagram, Globe } from "lucide-react";
import { Badge } from "./ui/badge";
import { cn } from "../lib/utils";

const ArtistCard = ({ artist, index = 0, className }) => {
  const firstName = artist.name.split(" ")[0];
  const Icon = artist.bookingType === "instagram" ? Instagram : Globe;

  return (
    <a
      href={artist.bookingUrl}
      target="_blank"
      rel="noreferrer noopener"
      className={cn("group block focus:outline-none focus-visible:ring-2 focus-visible:ring-primary", className)}
      aria-label={`Book with ${artist.name} - ${artist.specialty}`}
      data-testid={`artist-card-${artist.id}`}
    >
      <div className="relative aspect-[3/2] overflow-hidden bg-card">
        <img
          src={artist.image}
          alt={`${artist.name} - ${artist.specialty}`}
          loading="lazy"
          className="artist-img h-full w-full object-cover grayscale"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/90 via-background/10 to-transparent opacity-70 transition-opacity duration-700 group-hover:opacity-95" />

        <span className="display absolute left-4 top-3 text-xl text-foreground/60">
          {String(index + 1).padStart(2, "0")}
        </span>

        {artist.level === "junior" && (
          <Badge
            variant="outline"
            className="absolute right-4 top-4 rounded-none border-foreground/30 bg-background/50 text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground backdrop-blur"
          >
            Junior Artist
          </Badge>
        )}

        <div className="absolute inset-x-4 bottom-4 flex translate-y-3 items-center justify-between opacity-0 transition-[opacity,transform] duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100">
          <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-foreground">
            Book with {firstName}
          </span>
          <span className="flex h-10 w-10 items-center justify-center bg-primary text-primary-foreground">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
      </div>

      <div className="mt-4 flex items-start justify-between gap-4 border-t border-border pt-4">
        <div>
          <h3 className="display text-3xl uppercase tracking-wide transition-colors duration-300 group-hover:text-primary">
            {artist.name}
          </h3>
          <p className="mt-1 text-[11px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
            {artist.specialty}
          </p>
        </div>
        <span className="hidden shrink-0 items-center gap-1.5 text-[11px] text-muted-foreground sm:flex">
          <Icon className="h-3.5 w-3.5" />
          <span className="max-w-[140px] truncate">{artist.bookingLabel}</span>
        </span>
      </div>
    </a>
  );
};

export default ArtistCard;
